import React, { useState } from "react";
import ListCaixas from "./ListCaixas";
import CaixaAtual from "./CaixaAtual";

function PainelCaixas() {
  const [selectedTab, setSelectedTab] = useState('caixa_atual');

  // Função para lidar com a troca de abas
  const handleTabClick = (tab) => {
    setSelectedTab(tab);
  };

return (
  <div className='flex flex-col gap-2 mt-1 p-2 bg-slate-100 rounded-md shadow-md h-[85vh] overflow-hidden'>
    <h3 className='text-[14pt]'>Painel De Caixa</h3>
    <p className='text-[9pt] -mt-2'>gerencíe seus caixas.</p>
     {/* Abas */}
    <div className='flex border-b'>
      <button
        className={`py-2 px-4 ${selectedTab === 'caixa_atual' ? 'border-b-2 border-blue-500 font-semibold' : 'text-gray-500'}`}
        onClick={() => handleTabClick('caixa_atual')}
      >
        Caixa Atual
      </button>
      <button
        className={`py-2 px-4 ${selectedTab === 'caixas_passados' ? 'border-b-2 border-blue-500 font-semibold' : 'text-gray-500'}`}
        onClick={() => handleTabClick('caixas_passados')}
      >
        Caixas Passados
      </button>
    </div>

    {/* Componente exibido */}
    <div className='mt-2'>
      {selectedTab === 'caixa_atual' && <CaixaAtual />}
      {selectedTab === 'caixas_passados' && <ListCaixas />}
    </div>

  </div>
  );
}

export default PainelCaixas;